import { render, staticRenderFns } from "./user-build.vue?vue&type=template&id=30cc8912&"
import script from "./user-build.vue?vue&type=script&lang=js&"
export * from "./user-build.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports